<template>
  <ion-select
    interface="alert"
    :value="currentLanguage"
    @ionChange="changeLanguage($event.detail.value)"
  >
    <ion-select-option
      v-for="language in languages"
      :key="language.locale"
      :value="language.locale"
    >
      {{ language.title }}
    </ion-select-option>
  </ion-select>
</template>

<script>
import { i18n } from '@/plugins/i18n';

export default {
  name: 'LanguageComponent',
  data() {
    return {
      currentLanguage: this.$store?.state?.backConfig?.restaurant?.Language || i18n.locale,
    };
  },
  computed: {
    languages() {
      return [
        { locale: 'es', title: 'Español' },
        { locale: 'en', title: 'English' },
        { locale: 'fr', title: 'Français' },
        { locale: 'ar', title: 'العربية' },
        { locale: 'de', title: 'Deutsch' },
        { locale: 'zh', title: '中文' }
      ];
    },
    // Computed para acceder al restaurante actual
    currentRestaurant() {
      return this.$store?.state?.backConfig?.restaurant;
    }
  },
  watch: {
    // Observa cambios en el restaurante completo
    currentRestaurant: {
      handler(newRestaurant) {
        if (newRestaurant?.Language) {
          this.currentLanguage = newRestaurant.Language;
          i18n.locale = newRestaurant.Language;
        }
        if(!newRestaurant?.Language){
          this.currentLanguage = 'en'
          i18n.locale = 'en'
        }
      },
      deep: true,  // Importante para detectar cambios en propiedades anidadas
      immediate: true
    }
  },
  methods: {
    changeLanguage(locale) {
      this.currentLanguage = locale;
      i18n.locale = locale;
      // No actualizamos el store, solo actualizamos la UI
    }
  }
};
</script>

<!-- <template>
            
                <ion-select interface="popover"
                @ionChange="changeLanguage($event.target.value)" :value="currentLanguaje">
                    <ion-select-option v-for="language in languages" :key="language.locale" :value="language.locale" >{{language.locale}}</ion-select-option>
                </ion-select>
            

</template>

<script>
import { i18n } from '@/plugins/i18n'

export default{
    name: 'LanguageComponent',
    data: () => ({
        currentLanguaje: i18n.locale,
    }),
    computed: {
        languages() {
            return [
                { locale: 'es', title: this.$t('spanish') },
                { locale: 'en', title: this.$t('english') }
            ]
        }
    },
    methods: {
        changeLanguage(locale) {
            this.currentLanguaje = locale
            i18n.locale = locale
        }
    }
}
</script> -->


  